import React from 'react';
import { Route } from 'react-router-dom';
import ValueSection from '../pages/values/ValueSection';
import Values from '../pages/values/Values';
import CreateValue from '../pages/values/CreateValue';
import EditValue from '../pages/values/EditValue';
import ProtectedRoute from '../components/global/ProtectedRoute';

const valuesRoutes = (
    <>
        <Route
            path="/values/section"
            element={
                <ProtectedRoute requiredPermission="viewAny-value-section">
                    <ValueSection />
                </ProtectedRoute>
            }
        />

        <Route
            path="/values"
            element={
                <ProtectedRoute requiredPermission="viewAny-value">
                    <Values />
                </ProtectedRoute>
            }
        />

        <Route
            path="/values/create"
            element={
                <ProtectedRoute requiredPermission="create-value">
                    <CreateValue />
                </ProtectedRoute>
            }
        />

        <Route
            path="/values/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-value">
                    <EditValue />
                </ProtectedRoute>
            }
        />
    </>
);

export default valuesRoutes;
